import { giphyDarkestGrey, giphyLightestGrey } from '@giphy/js-brand'
import styled from 'styled-components'

export const Container = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: 6px;
    box-sizing: border-box;
    color: ${giphyLightestGrey};
    padding: 50px;
    position: relative;
    text-align: center;
`

export const Description = styled.p`
    line-height: 1.4;
    margin: 0 auto 1em;
    text-align: inherit;
`

export const Title = styled.h2`
    color: #fff;
    font-family: 'nexablack';
    font-size: 1.3em;
    font-weight: normal;
    margin-bottom: 0.7em;
`

export const Header = styled.div`
    ${Title}:last-child,
    ${Description}:last-child {
        margin-bottom: 1.5em;
    }
`

export const Sticker = styled.img`
    height: 80px;
    left: 50%;
    margin-left: -60px;
    object-fit: contain;
    pointer-events: none;
    position: absolute;
    top: -40px;
    width: 120px;
`
